import { connect } from 'react-redux';
import { createToolbarEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { translate } from '../../../base/i18n/functions';
import { IconConnectionInactive } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { cycleNkfForceBypass } from '../../actions';
import { getNkfForceBypass } from '../../functions';
/**
 * Debug toolbar item that forces a share of chunks to bypass the AEC.
 *
 * A bypassed chunk goes out as RAW MIC, so at anything between 0 and 100 the
 * transmitted audio alternates between cleaned and raw every 32 ms — two signals
 * that differ in level and timbre. The suspicion is that this alternation is
 * what users describe as a warble ("扇風機") rather than a dropout, and overload
 * is too hard to summon on demand to check that any other way.
 *
 * Cycles OFF → 30% (mixing) → 100% (all raw, the reference point) → OFF.
 *
 * Shown only when config.nkfAec.jankButton is true — a debug build, never a
 * normal deployment.
 */
class NkfForceBypassButton extends AbstractButton {
    accessibilityLabel = 'toolbar.accessibilityNkfForceBypass';
    icon = IconConnectionInactive;
    label = 'toolbar.nkfForceBypass';
    toggledLabel = 'toolbar.nkfForceBypass';
    tooltip = 'toolbar.nkfForceBypass';
    /**
     * Steps to the next share.
     *
     * @override
     * @protected
     * @returns {void}
     */
    _handleClick() {
        const { _pct, dispatch } = this.props;
        sendAnalytics(createToolbarEvent('nkf.forcebypass', { from: _pct }));
        dispatch(cycleNkfForceBypass());
    }
    /**
     * Shows the current share, so the toolbar says which of the three states we
     * are in without opening anything.
     *
     * @override
     * @protected
     * @returns {string}
     */
    _getLabel() {
        const { _pct } = this.props;
        if (_pct === 0) {
            return 'toolbar.nkfForceBypass';
        }
        return _pct >= 100 ? 'toolbar.nkfForceBypassAll' : 'toolbar.nkfForceBypassMix';
    }
    /**
     * Same wording on hover — the main toolbar shows only the icon.
     *
     * @override
     * @protected
     * @returns {string}
     */
    _getTooltip() {
        return this._getLabel();
    }
    /**
     * Toggled (ON) whenever any forcing is active.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._pct > 0;
    }
}
/**
 * Maps part of the redux state to the component's props.
 *
 * @param {IReduxState} state - The redux state.
 * @returns {Object}
 */
function mapStateToProps(state) {
    return {
        _pct: getNkfForceBypass(state)
    };
}
export default translate(connect(mapStateToProps)(NkfForceBypassButton));
